module.exports = __webpack_public_path__ + "img/green-energy-ic.220a7ae8.svg";